export const LOCALE_STORAGE_KEY = 'current_locale';
export const THEME_ID_STORAGE_KEY = 'theme_id_storage_key';
export const MT_UNSUPPORTED_RTL_LOCALES = ['ar', 'he'];
